import React from "react";
import swal from "sweetalert";
import Linkify from "react-linkify";
import { emojiIndex } from "emoji-mart";
import moment from "moment";
import * as actionTypes from "./actionTypes";
import { ShowLoader } from "./actions";

const toastr = require("toastr");

const isDevHost = location?.host?.includes("dev")

export const SiteUrl        = isDevHost ? "https://meet-dev.nxa.tel/" : "https://meet.nxa.tel/";

export const WebDomain      = isDevHost ?  "dev.nxa.tel"  : "nxa.tel";

export const AppLogin       = isDevHost ? "https://meet-dev.nxa.tel/login-via-token/" : "https://meet.nxa.tel/login-via-token/";

export const AppDomain      = isDevHost ? "meet-dev.nxa.tel" : "meet.nxa.tel" ;

export const apiBaseUrl     = isDevHost ? "https://api-dev.nxa.tel/" :  "https://api.nxa.tel/";

export const apiAdminUrl    = isDevHost ? "https://admin-api-dev.nxa.tel/"  : "https://admin-api.nxa.tel/";

export const apiMediaUrl    = isDevHost ? "https://media-api-dev.nxa.tel/" : "https://media-api.nxa.tel/";

export const meetingURL = () => {
    let url = location.href;
    if (location.search) {
        return url.replace(location.search, "");
    } else {
        return url;
    }
};

export const alertMsg = (msg, type = "") => {
    swal({
        title: msg,
        closeOnClickOutside: false,
        buttons: {
            cancel: false,
            confirm: true,
        },
        dangerMode: true,
    }).then((willDelete) => {
        if (willDelete) {
            if (type === "info") {
            } else if (type === "permission") {
                location.reload();
            } else {
                if (!window.navigator.userAgent.match(/(Electron)/)) {
                    location.href = "/";
                } else {
                    type();
                }
            }
        } else {
            console.log("you clicked on false");
        }
    });
};

export const langClient = async (data = {}) => {
    let headersJson = {
        "Content-Type": "application/json",
    };
    let bodyData = JSON.stringify(data);
    const request = new Request(`${translateApiUrl}`, {
        method: "POST",
        headers: new Headers(headersJson),
        body: bodyData,
    });
    const res = await fetch(request);
    const status = res.status;
    const response = await res.json();
    if (status === 200) {
        return response.data.translations[0].translatedText;
    }
    return "";
};

export const formatDate = (date) => {
    let newDate =
        (date.getMonth() > 8
            ? date.getMonth() + 1
            : "0" + (date.getMonth() + 1)) +
        "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
        "/" +
        date.getFullYear();
    return newDate;
};

export const galleryModeClass = (userCount) => {
    const galleryClass =
        userCount === 2
            ? "flexTwo"
            : userCount === 3
            ? "flexThree"
            : userCount === 4
            ? "flexFour"
            : userCount === 5
            ? "flexFive"
            : userCount === 6
            ? "flexSix"
            : userCount === 7
            ? "flexSeven"
            : userCount === 8
            ? "flexEight"
            : userCount === 9
            ? "flexNine"
            : userCount > 9 && userCount < 13
            ? "flexGrid-TW"
            : userCount >= 13 && userCount <= 15
            ? "flexGrid-ST"
            : userCount > 15
            ? "flexGrid-STT"
            : "";
    return galleryClass;
};

export const timeZoneArr = {
    PST: "Pacific",
    MST: "Mountain",
    CST: "Central",
    EST: "Eastern",
    BST: "British",
    CET: "Central European",
    EET: "Eastern European",
    AWT: "Australian Western",
    ACT: "Australian Central",
    AET: "Australian Eastern",
    NZT: "New Zealand",
    AST: "Middle East",
    IST: "India",
    JST: "Japan",
    SST: "Singapore",
};

export const startHourOptions = () => (
    <React.Fragment>
        <option value="01">1</option>
        <option value="02">2</option>
        <option value="03">3</option>
        <option value="04">4</option>
        <option value="05">5</option>
        <option value="06">6</option>
        <option value="07">7</option>
        <option value="08">8</option>
        <option value="09">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
    </React.Fragment>
);

export const startMinOptions = () => (
    <React.Fragment>
        <option>00</option>
        <option>05</option>
        <option>10</option>
        <option>15</option>
        <option>20</option>
        <option>25</option>
        <option>30</option>
        <option>35</option>
        <option>40</option>
        <option>45</option>
        <option>50</option>
        <option>55</option>
    </React.Fragment>
);

export const durationOptions = () => (
    <React.Fragment>
        <option value="15">15 Minutes</option>
        <option value="30">30 Minutes</option>
        <option value="60">1 Hour</option>
        <option value="120">2 Hours</option>
        <option value="240">4 Hours</option>
    </React.Fragment>
);

export const b64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
};

export const renderText = (message) => {
    return <Linkify>{message}</Linkify>;
};

export const renderPercentageUpload = (percentUploaded) => (
    <div className="progress">
        <div
            className="progress-bar progress-bar-success"
            role="progressbar"
            aria-valuenow={`${percentUploaded}`}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ width: `${percentUploaded}%` }}
        >
            {percentUploaded}%
        </div>
    </div>
);

export const colonToUnicode = (message) => {
    return message.replace(/:[A-Za-z0-9_+-]+:/g, (x) => {
        x = x.replace(/:/g, "");
        let emoji = emojiIndex.emojis[x];
        if (typeof emoji !== "undefined") {
            let unicode = emoji.native;
            if (typeof unicode !== "undefined") {
                return unicode;
            }
        }
        x = ":" + x + ":";
        return x;
    });
};

export const convertUtcToLocalTime = (utcTime) =>
    moment.utc(utcTime).local().format("YYYY-MM-DD HH:mm:ss");

export const translateLangOptions = () =>
    translateLangs.map((lang) => (
        <option value={lang.code}>{lang.name}</option>
    ));

const decodeHTML = (str) => {
    return str.replace(/&#([0-9]+);/g, function (full, int) {
        return String.fromCharCode(parseInt(int));
    });
};

export const textToSpeechPlay = (lang, message) => {
    var msg = new SpeechSynthesisUtterance();
    msg.text = decodeHTML(message);
    msg.lang = lang;
    speechSynthesis.speak(msg);
};

export const SecondsTohhmmss = (totalSeconds) => {
    let hours = Math.floor(totalSeconds / 3600);
    let minutes = Math.floor((totalSeconds - hours * 3600) / 60);
    let seconds = totalSeconds - hours * 3600 - minutes * 60;
    // round seconds
    seconds = Math.round(seconds * 100) / 100;
    let result = hours < 10 ? "0" + hours : hours;
    result += ":" + (minutes < 10 ? "0" + minutes : minutes);
    result += ":" + (seconds < 10 ? "0" + seconds : seconds);

    let [hour, minute, second] = result.split(":");
    result = hour === "00" ? `${minute}:${second}` : result;
    return result;
};

export const ApiRequest = (params) => {
    {
        params.loader && APP.store.dispatch(ShowLoader(true));
    }
    let headers = { "Content-Type": "application/json" };
    if (params.token) {
        headers = { ...headers, "X-Auth-Token": localStorage.getItem("token") };
    }
    let input = { method: params.method };
    if (params.body) {
        input = { ...params, body: JSON.stringify(params.body) };
    }
    input = { ...input, headers: new Headers(headers) };
    let url = params?.isAdminApiCall ? apiAdminUrl : apiBaseUrl;
    const request = new Request(`${url}${params.path}`, input);
    // const result    = await fetch(request);
    return fetch(request).then(async (apiresponse) => {
        let response = await apiresponse.json();
        {
            params.loader &&
                setTimeout(() => {
                    APP.store.dispatch(ShowLoader(false));
                }, params.loader_time);
        }
        let status = apiresponse.status;
        if (apiresponse.ok) {
            if (response.ResponseCode === "0") {
                {
                    params.alert &&
                        toastr.error(response.ResponseText, { timeOut: 1500 });
                }
            }
            if (response.ResponseCode === "1") {
                {
                    params.alert &&
                        toastr.success(response.ResponseText, {
                            timeOut: 1500,
                        });
                }
                {
                    params.reducer &&
                        APP.store.dispatch({
                            type: actionTypes[params.reducer],
                            payload: [],
                        });
                }
                {
                    params.reducer &&
                        APP.store.dispatch({
                            type: actionTypes[params.reducer],
                            payload: response.data,
                        });
                }
                APP.store.dispatch(ShowLoader(false));
                if (params.isLogin) {
                    if (
                        params?.body?.token &&
                        params.body.token === true &&
                        response.token
                    ) {
                        location.href = `${AppLogin}${response.token}`;
                    } else {
                        let properties = {
                            name: response.data.firstname,
                            fullname: `${response.data.firstname} ${response.data.lastname}`,
                        };
                        localStorage.setItem("token", response.token);
                        localStorage.setItem("type", response.data.type);
                        localStorage.setItem(
                            "customerID",
                            response.data.customerID
                        );
                        localStorage.setItem(
                            "properties",
                            JSON.stringify(properties)
                        );
                        localStorage.setItem(
                            "data",
                            JSON.stringify(response.data)
                        );
                    }
                }
            }
            return response;
        } else {
            if (status === 500 || status === 405) {
                {
                    params.alert &&
                        toastr.error("Internal Server error!", {
                            timeOut: 1500,
                        });
                }
                return status;
            }
            if (status === 401 || status === 400) {
                sessionStorage.clear();
                localStorage.clear();
                window.location.href = "/";
                return;
            }
            if (status !== 200) {
                {
                    params.alert &&
                        toastr.error("unknown error occured!", {
                            timeOut: 1500,
                        });
                }
                return status;
            }
        }
    });
};

export const apiClient = async (url = "", options = {}, type = null) => {
    return null;
};

export const getTimezones = (offset) => {
    let allTimeZones = {
        3600: "(GMT+01:00) West Central Africa",
        19800: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
        "-28800": "(GMT-08:00) Pacific Time (US & Canada) Tijuana",
        "-25200": "(GMT-07:00) Mountain Time(US & Canada)",
        "-21600": "(GMT-06:00) Central Time (US & Canada)",
        "-18000": "(GMT-05:00) Eastern Time (US & Canada)",
    };
    return allTimeZones?.[offset] ?? "";
};

export const loadScript = (src, ID = "myscript") => {
    let script = document.createElement("script");
    script.src = src;
    script.id = ID;
    document.head.append(script);
};

export const getDateDifferenceWithToday = (date) => {
    let dateofvisit = moment(date, "YYYY-MM-DD");
    let today = moment();
    let days = today.diff(dateofvisit, "days");
    return days;
};
